import * as React from "react";
const SvgChevronUp24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 8,
        fill: "black",
        viewBox: "0 0 12 8"
      },
      props
    ),
    React.createElement("path", { fill: "current", d: "m6 0 5.5 8H.5L6 0Z" })
  );
export default SvgChevronUp24Px;
